import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center mb-4" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "fw-bold" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_5 = { class: "p-0 text-secondary mb-3" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex mb-3"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "me-3",
  src: "/images/Location.png",
  style: {"max-height":"20px"}
}, null, -1)
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 1,
  class: "d-flex mb-3"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  class: "me-3",
  src: "/images/Phone.png"
}, null, -1)
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "d-flex mb-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  class: "me-3",
  src: "/images/Email.png",
  style: {"height":"12px","margin-top":"5px"}
}, null, -1)
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold mb-3" }, "Dine-in hours", -1)
const _hoisted_16 = { class: "p-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.restaurantDetails.logo_thumbnails.square_thumbnail)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.restaurantDetails.logo_thumbnails.square_thumbnail,
            class: "me-3"
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("span", null, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.restaurantDetails.name), 1),
        _createElementVNode("h6", null, [
          (_ctx.restaurantDetails.cuisines && _ctx.restaurantDetails.cuisines.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.restaurantDetails.cuisines[0].name), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_4
              ], 64))
        ])
      ])
    ]),
    _createElementVNode("ul", _hoisted_5, [
      (_ctx.restaurantDetails.address)
        ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(_ctx.getAddress(_ctx.restaurantDetails.address)) + " ", 1),
            (_ctx.restaurantDetails.location && _ctx.restaurantDetails.location && _ctx.restaurantDetails.location.longitude && _ctx.restaurantDetails.location.longitude)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: `https://www.google.com/maps/dir/?api=1&destination=${_ctx.restaurantDetails.location.latitude},${_ctx.restaurantDetails.location.longitude}`,
                  class: "ms-2 text-primary",
                  target: "_blank"
                }, " View on map ", 8, _hoisted_8))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.restaurantDetails.phone_number)
        ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("a", {
              href: `tel:${_ctx.restaurantDetails.phone_number}`,
              class: "text-secondary"
            }, _toDisplayString(_ctx.restaurantDetails.phone_number), 9, _hoisted_11)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("a", {
          href: `mailto:${_ctx.restaurantDetails.email}`,
          class: "text-secondary"
        }, _toDisplayString(_ctx.restaurantDetails.email), 9, _hoisted_14)
      ])
    ]),
    _hoisted_15,
    _createElementVNode("ul", _hoisted_16, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dine_in_hours, (date_item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: date_item.date,
          class: "d-flex mb-2"
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["text-uppercase fw-bold date-item", date_item.isToday ? 'text-primary' : 'text-muted'])
          }, _toDisplayString(date_item.date), 3),
          _createElementVNode("span", {
            class: _normalizeClass(date_item.isToday ? 'text-primary' : 'text-secondary')
          }, _toDisplayString(date_item.hours), 3)
        ]))
      }), 128))
    ])
  ]))
}